module.exports = __webpack_public_path__ + "static/img/subscription.f6fa3fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subscription.jpg
// module id = GSi6
// module chunks = 1